import { Link, NavLink } from 'react-router-dom'
import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import Brand from '../Brand/Brand'
import './Navbar.css'


const Navbar = () => {
    const [isActive, setActive] = useState(false)

    const toggleClass = () => {
        setActive(!isActive)
    }
    return (
        <>
            <nav>
                <Link to={'/'} className='d-flex justify-contents-center align-items-center'>
                    <Brand />
                </Link>
                <button onClick={toggleClass}>
                    <FontAwesomeIcon icon={faBars} />
                </button>
                <section>
                    <NavLink to={'/'} className={({ isActive }) => isActive ? 'selected' : ''}>
                        Inicio
                    </NavLink>
                    <NavLink to={'/frio-industrial'} className={({ isActive }) => isActive ? 'selected' : ''}>
                        Frío Industrial
                    </NavLink>
                    <NavLink to={'/laboratorio'} className={({ isActive }) => isActive ? 'selected' : ''}>
                        Laboratorio
                    </NavLink>
                    <NavLink to={'/farmacia'} className={({ isActive }) => isActive ? 'selected' : ''}>
                        Farmacia
                    </NavLink>
                    <NavLink to={'/climatizacion'} className={({ isActive }) => isActive ? 'selected' : ''}>
                        Climatización
                    </NavLink>
                    <NavLink to={'/contacto'} className={({ isActive }) => isActive ? 'selected' : ''}>
                        Contacto
                    </NavLink>
                </section>
            </nav>

            <div className={`menu ${isActive ? 'open' : ''}`}>
                <Link to={'/'}>
                    Inicio
                </Link>
                <Link to={'/frio-industrial'}>
                    Frío Industrial
                </Link>
                <Link to={'/laboratorio'}>
                    Laboratorio
                </Link>
                <Link to={'/farmacia'}>
                    Farmacia
                </Link>
                <Link to={'/climatizacion'}>
                    Climatización
                </Link>
                <Link to={'/contacto'}>
                    Contacto
                </Link>
            </div>
        </>
    )
}

export default Navbar